"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PacketHeader = function PacketHeader(bitReader) {
  _classCallCheck(this, PacketHeader);

  this.syncByte = bitReader.readBits(8);
  this.TEI = bitReader.readBit();
  this.PUSI = bitReader.readBit();
  this.PRIORITY = bitReader.readBit();
  this.PID = bitReader.readBits(13);
  this.TSC = bitReader.readBits(2);
  this.AdaptationFieldControl = bitReader.readBits(2);
  this.ContinuityCounter = bitReader.readBits(4);
  this.length = 4; // 01 – no adaptation field, payload only,
  // 10 – adaptation field only, no payload,
  // 11 – adaptation field followed by payload,
  // 00 - RESERVED for future use [9]

  switch (this.AdaptationFieldControl) {
    case 1:
      break;

    case 2:
    case 3:
      this.adaptationField = new AdaptationField(bitReader);
      this.length += this.adaptationField.length;

    case 0:
      break;
    // console.log('reserved');
  }
};

var AdaptationField = function AdaptationField(bitReader) {
  _classCallCheck(this, AdaptationField);

  this.length = bitReader.readBits(8);
  var afterLength = bitReader.currentBit();
  this.discontinuityIndicator = bitReader.readBit();
  this.randomAccessIndicator = bitReader.readBit();
  this.esProfileIndicator = bitReader.readBit();
  this.pcrFlag = bitReader.readBit();
  this.opcrFlag = bitReader.readBit();
  this.splicingPointFlag = bitReader.readBit();
  this.transportPrivateFlag = bitReader.readBit();
  this.adaptationFieldExtFlag = bitReader.readBit();

  if (this.pcrFlag) {
    this.pcrBase = bitReader.readBits(33);
    this.pcrConst = bitReader.readBits(6);
    this.pcrExt = bitReader.readBits(9);
  }

  if (this.opcrFlag) {
    this.opcr = bitReader.readBit(48);
  }

  if (this.splicingPointFlag) {
    this.spliceCountdown = bitReader.readBits(8);
  }

  if (this.transportPrivateFlag) {
    this.transportPrivateDataLength = bitReader.readBits(8);
    this.transportPrivateData = bitReader.readBits(this.transportPrivateDataLength * 8);
  }

  if (this.adaptationFieldExtFlag) {
    this.adaptionFieldExt = new AdaptationFieldExtension(bitReader);
    this.length += this.adaptionFieldExt.length;
  }

  var afterParse = bitReader.currentBit();
  var bytesLeft = this.length - (afterParse / 8 - afterLength / 8); /// Flush Stuffing

  if (bytesLeft > 0) {
    while (bytesLeft > 0) {
      bitReader.readBits(8);
      bytesLeft -= 1;
    }
  }
};

var AdaptationFieldExtension = function AdaptationFieldExtension(bitReader) {
  _classCallCheck(this, AdaptationFieldExtension);

  this.length = bitReader.readBits(8);
  this.ltwFlag = bitReader.readBit();
  this.piecewiseRateFlag = bitReader.readBit();
  this.seamlessSpliceFlag = bitReader.readBit();
  bitReader.readBits(5); // reserved

  if (this.ltwFlag) {
    this.ltwValidFlag = bitReader.readBit();
    this.ltwOffset = bitReader.readBits(15);
  }

  if (this.piecewiseRateFlag) {
    bitReader.readBits(2); // reserved

    this.piecewiseRate = bitReader.readBits(22);
  }

  if (this.seamlessSpliceFlag) {
    this.spliceType = bitReader.readBits(4);
    this.dtsNextAccessUnit = bitReader.readBits(36);
  }
};

var _default = PacketHeader;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@krad/plainview/node_modules/@krad/slugline/distribution/parsers/container/ts/packet-header.js
// module id = 473
// module chunks = 0